// The SIP library already parses display_name; never inspect a raw SIP header here.
export const callerName = (
  sipName?: string,
  leadName?: string
): string | undefined =>
  sipName && /\p{L}/u.test(sipName) ? sipName : leadName;
